// Date utilities that handle timezone correctly

/**
 * Get today's date in YYYY-MM-DD format using LOCAL timezone (not UTC)
 * This is important because toISOString() converts to UTC which can cause
 * date mismatches when the user is in a timezone behind UTC.
 */
export function getLocalDateString(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Get today's date string in local timezone
 */
export function getTodayString() {
  return getLocalDateString(new Date());
}

/**
 * Get tomorrow's date string in local timezone
 */
export function getTomorrowString() {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return getLocalDateString(tomorrow);
}

/**
 * Check if a date string represents today (in local timezone)
 */
export function isToday(dateString) {
  return dateString === getTodayString();
}

/**
 * Check if a date string represents a past date (in local timezone)
 */
export function isPastDate(dateString) {
  return dateString < getTodayString();
}

/**
 * Check if a date string represents a future date (in local timezone)
 */
export function isFutureDate(dateString) {
  return dateString > getTodayString();
}

/**
 * Format a date string (YYYY-MM-DD) for display as MM/DD/YY
 */
export function formatDisplayDate(dateString) {
  if (!dateString) return '';
  const [year, month, day] = dateString.split('-');
  if (!year || !month || !day) return dateString;
  const shortYear = year.slice(-2);
  return `${month}/${day}/${shortYear}`;
}

/**
 * Format a date string (YYYY-MM-DD) for display as MM/DD/YYYY
 */
export function formatDisplayDateLong(dateString) {
  if (!dateString) return '';
  const [year, month, day] = dateString.split('-');
  if (!year || !month || !day) return dateString;
  return `${month}/${day}/${year}`;
}
